import React from 'react';
import RecommendJobCard from './RecommendJobCard';
import './recommendedJobsItems.css';
import useRecommendedJobs from '../../../hooks/jobs/useRecommendedJobs';
import Slider from 'react-slick';

const RecommendedJobItems = () => {
  const { items, loading, error } = useRecommendedJobs();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <div className="recommended-job-items__loading-container fade-in">
        <div className="recommended-job-items__loading-spinner"></div>
        <p className="recommended-job-items__loading-text">Cargando</p>
      </div>
    );
  }

  if (error) {
    return <div>Error loading jobs: {error.message}</div>;
  }


  return (
    <div className="recommended-job-items__container" id="job-items-container">
      <div className="recommended-jobs-items__title-container">
        <h2> ANUNCIOS DESTACADOS</h2>
        <h3>ENCUENTRA OPORTUNIDADES LABORALES</h3>
      </div>
      
      <Slider {...settings}>
        {items.map((item) => (
          <div key={item.id}>
            <RecommendJobCard data={item} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RecommendedJobItems;

